import { Injectable, inject } from '@angular/core';
import { safelyCreateHttpParams } from './api/api-utils';
import { components, operations } from './api/generated/ix-api.types';
import { IxRestApi } from './api/ix-rest-api';

export type ResponsibleDisciplineDto = components['schemas']['ResponsibleDisciplineDto'];
export type ResponsibleDisciplineOutputDto = components['schemas']['ResponsibleDisciplineOutputDto'];
export type ResponsibleDisciplineStatus = ResponsibleDisciplineOutputDto['status'];
export type ResponsibleDisciplineType = ResponsibleDisciplineOutputDto['type'];
export type NonNullableResponsibleDisciplineType = Exclude<ResponsibleDisciplineType, undefined>;

@Injectable({ providedIn: 'root' })
export class ProjectApiService {
  readonly #ixRestApi = inject(IxRestApi);

  getActiveDisciplines(path: operations['getActiveDisciplines']['parameters']['path']) {
    return this.#ixRestApi.get({
      pathname: '/api/projects/{projectId}/activedisciplines',
      options: { path },
    });
  }

  getAllProjects() {
    return this.#ixRestApi.get({ pathname: '/api/projects', options: {} });
  }

  getClassifications(
    path: operations['getClassifications']['parameters']['path'],
    query?: operations['getClassifications']['parameters']['query'],
  ) {
    return this.#ixRestApi.get(
      {
        pathname: '/api/projects/{projectId}/classifications',
        options: { path },
      },
      { params: safelyCreateHttpParams(query) },
    );
  }

  getMeasures(path: operations['getMeasures']['parameters']['path']) {
    return this.#ixRestApi.get({
      pathname: '/api/projects/{projectId}/measures',
      options: { path },
    });
  }

  getUnits(path: operations['getUnits']['parameters']['path']) {
    return this.#ixRestApi.get({
      pathname: '/api/projects/{projectId}/units',
      options: { path },
    });
  }

  createProject(query: operations['createProject']['parameters']['query']) {
    return this.#ixRestApi.post({ pathname: '/api/projects', options: {} }, undefined, {
      params: safelyCreateHttpParams(query),
    });
  }

  updateProject(
    path: operations['updateProject']['parameters']['path'],
    query: operations['updateProject']['parameters']['query'],
  ) {
    return this.#ixRestApi.put({ pathname: '/api/projects/{projectId}', options: { path } }, undefined, {
      params: safelyCreateHttpParams(query),
    });
  }

  deleteProject(path: operations['deleteProject']['parameters']['path']) {
    return this.#ixRestApi.delete({ pathname: '/api/projects/{projectId}', options: { path } });
  }
}
